module.exports = __webpack_public_path__ + "static/media/yellow04.f53efdf1.svg";